import { ref } from 'vue'
import api from '@/services/api'
import { parseRecebiveisJson } from '@/utils/clienteRecebivelApi'
import { useWorkspaceStaffAccess } from '@/composables/useWorkspaceStaffAccess'

export function useRecebivelStaffDelete({ workspaceIdRef, clienteIdRef, onDeleted }) {
  const { canStaffManage, loadStaffRole } = useWorkspaceStaffAccess(workspaceIdRef)

  const confirmDeleteTarget = ref(null)
  const deleting = ref(false)

  function requestDeleteRecebivel(item) {
    confirmDeleteTarget.value = item
  }

  function cancelDeleteRecebivel() {
    if (deleting.value) return
    confirmDeleteTarget.value = null
  }

  async function confirmDeleteRecebivel() {
    const target = confirmDeleteTarget.value
    const clienteId = clienteIdRef?.value
    if (!target?.id || !clienteId || deleting.value) return
    deleting.value = true
    try {
      const { data } = await api.delete(
        `/clientes/${clienteId}/recebiveis/${encodeURIComponent(String(target.id))}`
      )
      confirmDeleteTarget.value = null
      await onDeleted?.(parseRecebiveisJson(data?.recebiveisJson))
    } catch (error) {
      console.error('Erro ao excluir recebível:', error)
    } finally {
      deleting.value = false
    }
  }

  return {
    canDeleteRecebivel: canStaffManage,
    confirmDeleteTarget,
    deleting,
    loadStaffRole,
    requestDeleteRecebivel,
    cancelDeleteRecebivel,
    confirmDeleteRecebivel
  }
}
